import { translate, IText } from "../../utils/translator";
import { IDraggableHandler } from "../../components/drag-and-drop/models";
import { ScopeType } from "../scopes/scope-type-service";

export enum ReportedServiceDataItemType {
	Measure = "Measure",
	PerformanceIndicator = "PerformanceIndicator"
}

export interface IAttachedDataItemBase {
	serviceId: string;
	dataItemName: string;
	sortOrder: number;
	serviceStructureId?: string;
}

export interface IAttachedDataItem extends IAttachedDataItemBase {
	id: string;
	type: ReportedServiceDataItemType;
	dataItemId: string;
	dataItemSpecifier: string;
	description: string;
	ruleReferenceInfo: string;
}

export class AttachedDataItem implements IDraggableHandler {
	id: string;
	sortOrder: number;
	serviceId: string;
	dataItemId: string;
	dataItemName: string;
	dataItemSpecifier: string;
	dataItemUnit: string;
	description: string;
	ruleReferenceInfo: string;
	isDragged: boolean = false;
	scopeTypeIds: string[];
	type: ReportedServiceDataItemType;
	scopeTypeGroupId: string;
	isForCustomerComparison: boolean;
	forServiceTotal: boolean;
	forServiceByMunicipalities: boolean;
	forCostCentersTotal: boolean;
	forCostCentersByMunicipalities: boolean;

	constructor(init?: Partial<AttachedDataItem>) {
		Object.assign(this, init);
	}

	get displayName(): string {
		let name = this.dataItemName;
		if (this.dataItemSpecifier) {
			name = `${name} (${this.dataItemSpecifier})`;
		}
		return name;
	}

	onDragStart(event, data: AttachedDataItem) {
		if (event.stopPropagation) {
			event.stopPropagation();
		}

		this.isDragged = true;

		event.dataTransfer.effectAllowed = "move";
		const json = JSON.stringify(data);
		event.dataTransfer.setData("application/json", json);
	}

	onDragEnd(event, data: any): void {
		this.isDragged = false;
	}
}
